import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { PlanSuggestionInfo, AccountTrialStatus, AccountTierFields, AccountRoleInfo, AccountManagedByAdobe, AccountOwner, SubscriptionInfo, AccountLockingInfo, AccountPlanAndTrialInfo } from '../../types/generated/Account.schema';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetFeatureGateSuggestionsQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetFeatureGateSuggestionsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, managedBy?: Types.AccountManagementTypes | null, tier?: Types.AccountTier | null, subscription: { __typename?: 'AccountSubscription', id: string, discountOfferExpiresAt?: string | null, suggestedPlan?: Array<{ __typename?: 'PlanSuggestion', disabledInCurrentAccount: boolean, feature: string, includedInCurrentPlan: boolean, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, period: Types.PlanPeriod, tier: Types.PlanTier, title: string, userLimit?: number | null, version?: number | null } | null } | null> | null, plan?: { __typename?: 'Plan', cost: number, id: string, name?: string | null, paymentMethod: Types.PlanPaymentMethod, period: Types.PlanPeriod, tier: Types.PlanTier, version?: number | null } | null, trial: { __typename?: 'SubscriptionTrial', isActive: boolean } }, owner?: { __typename?: 'Owner', id: string, name: string, email: string } | null, role?: { __typename?: 'Role', id: string, name: string } | null } | null };


export const GetFeatureGateSuggestions = /*#__PURE__*/ gql`
    query GetFeatureGateSuggestions($accountId: ID!) {
  account(accountId: $accountId) {
    ...AccountPlanAndTrialInfo
    ...AccountOwner
    ...AccountManagedByAdobe
    ...AccountRoleInfo
    ...AccountTierFields
    ...AccountTrialStatus
    id
    subscription {
      id
      suggestedPlan {
        ...PlanSuggestionInfo
        disabledInCurrentAccount
      }
    }
  }
}
    ${AccountPlanAndTrialInfo}
${AccountOwner}
${AccountManagedByAdobe}
${AccountRoleInfo}
${AccountTierFields}
${AccountTrialStatus}
${PlanSuggestionInfo}` as unknown as DocumentNode<GetFeatureGateSuggestionsQuery, GetFeatureGateSuggestionsQueryVariables>;

          

          export const useGetFeatureGateSuggestionsQuery = (options?:QueryHookOptions<GetFeatureGateSuggestionsQuery, GetFeatureGateSuggestionsQueryVariables>) => useQuery(GetFeatureGateSuggestions, options);

          

          export type GetFeatureGateSuggestionsQueryOptions = QueryHookOptions<GetFeatureGateSuggestionsQuery, GetFeatureGateSuggestionsQueryVariables>;

          

          export const useGetFeatureGateSuggestionsLazyQuery = (options?:LazyQueryHookOptions<GetFeatureGateSuggestionsQuery, GetFeatureGateSuggestionsQueryVariables>) => useLazyQuery(GetFeatureGateSuggestions, options);

          

          export type GetFeatureGateSuggestionsQueryResult = ReturnType<typeof useGetFeatureGateSuggestionsQuery>;

          
